import { Close, Done } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "@refinedev/core";
import { useCurrency } from "../../../../../hooks/useCurrency";

type CompetitionBoxProps = {
  title: string;
  price: number;
  percentage?: number;
  isWon?: boolean;
};

export const CompetitionBox = (props: CompetitionBoxProps) => {
  const { title, price, percentage, isWon } = props;
  const { translate } = useTranslation();
  const { formatCurrency } = useCurrency();
  const Icon = isWon ? Done : Close;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        color: isWon ? "#2E8B57" : "gray",
        borderRadius: "4px",
        padding: "0 4px",
        marginBottom: "4px",
        width: "fit-content",
        borderColor: isWon ? "#2E8B57" : "gray",
        border: "1px solid",
      }}
    >
      <Typography variant="caption" mr={"2px"}>
        {title}: {price ? formatCurrency(price) : translate("common.unknown")}
      </Typography>
      {Boolean(price) && (
        <>
          {percentage && (
            <Typography fontSize="10px" textAlign="center" mr={1}>
              ({percentage}%)
            </Typography>
          )}
          <Icon sx={{ width: "16px", height: "16px" }} />
        </>
      )}
    </Box>
  );
};
